const uptcProps = [
  {
    required: true,
    key: 'hash',
    text: 'Product ID',
  },
  {
    required: true,
    key: 'name',
    text: 'Name',
  },
  {
    key: 'productcode',
    text: 'Product Code',
  },
  {
    key: 'barcode',
    text: 'Barcode',
  },
  {
    key: 'otherurl',
    text: 'Competitor URL',
    multiple: true,
  },
]

export default uptcProps
